import React, { useCallback, useMemo } from 'react'
import { matchPath } from 'react-router'

import LineExclamationCircleIcon from 'components/Luxkit/Icons/line/LineExclamationCircleIcon'
import SolidTimesCircleIcon from 'components/Luxkit/Icons/solid/SolidTimesCircleIcon'
import { showSnackbar } from 'components/Luxkit/Snackbar/AppSnackbar'
import { createTripSummaryUrl } from 'tripPlanner/utils'

export const DEFAULT_SNACKBAR_SAVE_ITEM_UPDATE_MESSAGE = 'Update successful'

export const useUpdateSavedItemBookmarkHandlers = () => {
  const isAlreadyOnTrip = useMemo(
    () =>
      !!matchPath('/trip/:tripId/:tab', {
        exact: false,
      }),
    [],
  )

  const showUpdateSuccessSnackbar = useCallback(
    (message: string, tripId: string, itemId: string) =>
      showSnackbar(message, 'neutral', {
        icon: <LineExclamationCircleIcon colour="neutral-one" />,
        action: !isAlreadyOnTrip
          ? {
              label: 'View',
              to: createTripSummaryUrl({ tripId, id: itemId }),
            }
          : undefined,
      }),
    [isAlreadyOnTrip],
  )

  const showUpdateErrorSnackbar = useCallback(
    () =>
      showSnackbar('Failed to update saved offer', 'critical', {
        icon: <SolidTimesCircleIcon colour="critical" />,
      }),
    [],
  )

  return {
    showUpdateSuccessSnackbar,
    showUpdateErrorSnackbar,
  }
}
